import { Checkbox, Form } from "antd";
import React from "react";
import { cardioTherapyOptions } from "../../../../IpEMR/Options/physioOptions";
import DeselectableRadioGroup from "../../../../../blocks/FormItems/DeselectableRadioGroup";
import DynamicInputFields from "../../../../../blocks/FormItems/DynamicInputFields";

const CardioTherapyForm = ({ onValuesChange, formData }) => {
  const [form] = Form.useForm();

  const selectedTherapy = Form.useWatch("others", form);
  const showOthers = selectedTherapy ?? false;
  return (
    <>
      <Form
        id="op-cardio-therapy"
        form={form}
        onValuesChange={(cur, all) => onValuesChange("therapy", all)}
        layout="vertical"
        className="ip-forms"
        initialValues={formData?.therapy}
      >
        {cardioTherapyOptions?.map((option) => (
          <DeselectableRadioGroup
            label={option?.label}
            name={option?.name_key}
            options={option?.options}
            form={form}
          />
        ))}
        <Form.Item name={"others"} valuePropName="checked">
          <Checkbox>Others</Checkbox>
        </Form.Item>
        {showOthers && (
          <DynamicInputFields
            field_key={"others"}
            form={form}
            inputStyle={{ maxWidth: 800 }}
          />
        )}
      </Form>
    </>
  );
};

export default CardioTherapyForm;
